module.exports = __webpack_public_path__ + "media/small_prehistoric_cave.47561896.wav";